import React, { ComponentProps as CP } from 'react'
import { storiesOf } from '@storybook/react'

import { MemoryRouter } from 'react-router'
import { PlayerPosition } from 'protos'
import ProfileScreen from 'routes/Profile/ProfileScreen'

const data: CP<typeof ProfileScreen> = {
  infoTab: {
    mostSelected: {
      player: {
        name: 'C. Ronaldo',
        jersey: { baseColor: 'FFFFFF', jerseyNumber: '7', numberColor: '000000', sleeveColor: '000000' },
      },
      team: {
        name: 'Juventus',
        jersey: { baseColor: 'FFFFFF', numberColor: '000000', sleeveColor: '000000' },
      },
    },
    userInfo: {
      username: 'John Snow',
      avatarUrl: 'http://i.pravatar.cc/80',
      playedGames: 3456,
      winnings: [{ value: 3456732 }],
      wins: 1230,
    },
    vitalStatistics: {
      topPlayerScore: {
        player: {
          name: 'C. Ronaldo',
          jersey: { baseColor: 'FFFFFF', jerseyNumber: '7', numberColor: '000000', sleeveColor: '000000' },
          team: { name: 'Juventus' },
          position: PlayerPosition.PP_ATTACKER,
        },
        score: 435,
      },
      topTeamScore: {
        match: {
          awayTeam: { name: 'Juventus' },
          homeTeam: { name: 'Chelsea' },
          kickoff: Math.round(Date.now() / 1000),
        },
        score: 865,
      },
    },
    hasActiveMembership: false,
  },
  achievementsTab: {
    achievements: [

    ],
    achievementsTotal: 2,
    achievementsUnlocked: 0,
  },
}

storiesOf('ProfileScreen', module)
  .addDecorator((story) => (
    <MemoryRouter initialEntries={['/profile']}>
      {story()}
    </MemoryRouter>
  ))
  .add('default', () => (
    <ProfileScreen
      infoTab={{
        mostSelected: {},
        userInfo: {},
        vitalStatistics: {},
        hasActiveMembership: false,
      }}
      achievementsTab={{ achievements: [], achievementsTotal: 0, achievementsUnlocked: 0 }}
    />
  ))
  .add('with data', () => (
    <ProfileScreen {...data} />
  ))
